module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("Copyright © 2016")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("By T. J. Ray")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("The word “Pelican” and the depiction of a pelican are")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("trademarks of Pelican Publishing Company, Inc., and are")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("registered in the U.S. Patent and Trademark Office.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("Ray, T. J., author.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("Side by side : moonshine and murder in Mississippi / by T.J. Ray.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("ISBN 978-1-4556-2183-5 (pbk. : alk. paper) — ISBN 978-1-4556-2184-2 (e-book) 1. Mathis, Will, -1902. 2. Murder—Mississippi—Oxford—Case studies. 3. Oxford (Miss.)—History—20th century. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("HV6534.O94R39 2016")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("364.152’3092276283--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("2015030524")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-10"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('div', {
    staticClass: "frame-2"
  }, [_c('img', {
    staticClass: "frame-4",
    attrs: {
      "alt": "40948.jpg",
      "src": "Images/40948.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("Published by Pelican Publishing Company, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-11"
  }, [_c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("1000 Burmaster Street, Gretna, Louisiana 70053")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5f17752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Copyright.vue
// module id = 63
// module chunks = 0